import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { GET_WS } from "./actionTypes";
import { getWorkstationsSuccess, getWorkstationsError } from "./actions";

// Include call API
import { getWorkstationsAPI } from "../../../api/workstations";

const workstationAPI = getWorkstationsAPI();

function* getAllWorkstations({ payload: { user } }) {
  try {
    const response = yield call(workstationAPI.getAllWS, user.token);
    yield put(getWorkstationsSuccess(response.WorkStations, response.message));
  } catch (error) {
    yield put(getWorkstationsError(error));
  }
}

export function* watchGetWorkstations() {
  yield takeEvery(GET_WS, getAllWorkstations);
}

function* getWorkstationsSaga() {
  yield all([fork(watchGetWorkstations)]);
}

export default getWorkstationsSaga;
